module.exports = __webpack_public_path__ + "img/icon_medezinische_hilfsmittel.2ec0b1dc.svg";